import React from 'react'

import { Button, Icon, ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, number, shape, string } from 'prop-types'

import ImageMosaic from 'Pods/Shared/ImageMosaic/ImageMosaic'

import { BROWSE_ALL_MOSAIC_IMAGES } from '../Mocks/mockData'


function BrowseAllModelsSection({
  title = "Can't find the right collection?",
  description = 'Browse the full catalog to explore thousands of models.',
  buttonText = 'Browse all models',
  buttonHref = '/3d-models?page=1',
  images = BROWSE_ALL_MOSAIC_IMAGES,
}) {
  const mosaicImages = images?.length >= 4 ? images : BROWSE_ALL_MOSAIC_IMAGES

  return (
    <section className="collection-hub-browse-section" aria-label="Browse all models">
      <div className="collection-hub-browse-section__banner">
        <div className="collection-hub-browse-section__content">
          <div className="collection-hub-browse-section__heading">
            <h2 className="collection-hub-browse-section__title">{title}</h2>
            <p className="collection-hub-browse-section__description">{description}</p>
          </div>
          <div className="collection-hub-browse-section__action">
            <Button
              type="primary"
              trailIcon={<Icon svgComponent={ArrowRight} size="small" />}
              href={buttonHref}
              size="small"
            >
              {buttonText}
            </Button>
          </div>
        </div>
        <div className="collection-hub-browse-section__mosaic">
          <ImageMosaic images={mosaicImages} staggered lazy />
        </div>
      </div>
    </section>
  )
}

BrowseAllModelsSection.propTypes = {
  title: string,
  description: string,
  buttonText: string,
  buttonHref: string,
  images: arrayOf(
    shape({
      id: string.isRequired,
      url: string.isRequired,
      alt: string.isRequired,
      order: number,
    })
  ),
}

export default BrowseAllModelsSection
